import { formatDuration } from '@shared/time.ts'
import { type Component, Show } from 'solid-js'

type Props = {
  /** 放送位置とのずれ（秒）。正なら再生が遅れている */
  drift: number
  onReturn: () => void
}

/**
 * 放送位置から外れているときに出す（要件定義 3.4）。
 *
 * 834CH 自体の放送時刻は動かさないので、
 * ここでできるのは「いまの放送位置に追いつく」ことだけ。
 */
export const ReturnToLive: Component<Props> = (props) => (
  <div>
    <button
      type="button"
      onClick={props.onReturn}
      class="inline-flex items-center gap-2 rounded-full border border-ch-onair/40 bg-ch-onair/10 px-3 py-1.5 text-xs font-semibold text-ch-onair transition-colors hover:bg-ch-onair/20"
    >
      <span class="size-1.5 rounded-full bg-ch-onair" aria-hidden="true" />
      放送中の位置に戻る
      <Show when={Math.abs(props.drift) >= 1}>
        <span class="font-mono font-normal text-ch-muted tabular">
          {props.drift > 0 ? '-' : '+'}
          {formatDuration(Math.abs(props.drift))}
        </span>
      </Show>
    </button>
  </div>
)
